import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/base/FaqAccordion";
import { faqItems } from "@/mocks/content";
import { SITE } from "@/config/site";

export default function HomeFaqSection() {
  const preview = faqItems.slice(0, 5);

  return (
    <section className="w-full border-y border-background-200/70 bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="FAQ"
        title="观看前常被问到的问题"
        desc="关于实时画面信号、声音开关、连麦申请与回看时长，这里先回答最常被问到的一部分。"
      />

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12 md:mt-10 lg:gap-8">
        <div className="lg:col-span-4">
          <div className="flex h-full flex-col justify-between rounded-lg border border-background-200/70 bg-background-50 p-6">
            <div>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-customer-service-2-line text-xl" aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                还有别的疑问？
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">
                你的问题没在列表里？可以直接发邮件给编辑组，我们会在工作时段内回复，
                涉及投稿与连麦的邮件会优先处理。
              </p>
              <a
                href={`mailto:${SITE.email}`}
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-primary-500 transition-colors hover:text-primary-600"
              >
                <i className="ri-mail-send-line" aria-hidden="true" />
                {SITE.email}
              </a>
            </div>
            <Link
              to="/faq"
              className="mt-6 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 px-4 py-2.5 text-[13px] text-foreground-800 transition-colors hover:border-primary-500/60 hover:text-primary-500"
            >
              查看完整常见问题
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} className="bg-background-50" />
        </div>
      </div>
    </section>
  );
}